import { getEnv } from '@shared/utils/env';

export const PATHS = {
  HOME: getEnv().VITE_ROOT_PATH || '/',
  LOGIN: '/auth/login',
  PROFILE: '/perfil',
  TENANT: '/auth/tenants',
  SUBSIDIARY: '/crspSubsidiaryManagement',
  LOGIN_TENANT: '/auth/login',
  PROFILE2: '/perfil',
} as const;
